import { App as AntdApp } from "antd";
import { useMutations } from "./useApiMutation";
import { useCallback } from "react";

export function useConfirm() {
  const { modal } = AntdApp.useApp();
  const { mutate } = useMutations();

  const confirmAction = useCallback(
    ({
      key,
      method = "delete",
      endpoint,
      payload = null,
      params = null,
      onSuccess,
      title = "Are you sure?",
      content = "Please confirm this action",
      okText = "OK",
      okType = "primary",
      cancelText = "Cancel",
      zIndex,
      getContainer,
    }) => {
      return modal.confirm({
        title,
        content,
        okText,
        okType,
        cancelText,
        centered: true,
        zIndex,
        getContainer,
        // onSuccess is handed to mutate, which invokes it once with the unwrapped
        // payload and only when the call actually succeeded. Calling it again here
        // would fire it a second time — and also on failure.
        onOk: () => mutate(key, { method, endpoint, payload, params, onSuccess }),
      });
    },
    [modal, mutate]
  );

  return { confirmAction };
}
